var Filter = /** @class */ (function () {
    function Filter(rules) {
        if (rules === void 0) { rules = []; }
        this.rules = rules;
    }
    Filter.prototype.addRule = function (rule) {
        this.rules.push(rule);
        return this;
    };
    Filter.prototype.reset = function () {
        this.rules = [];
        return this;
    };
    Filter.prototype.apply = function (object) {
        for (var i = 0; i < this.rules.length; i++) {
            var result = this.rules[i].apply(object);
            if (!result) {
                return false;
            }
        }
        return true;
    };
    Filter.prototype.resetAllFilters = function () {
        this.rules.forEach(function (rule) {
            if (rule.includeInReset) {
                rule.value = null;
            }
        });
    };
    Filter.prototype.getFilterByName = function (name) {
        return this.rules.find(function (rule) {
            return rule.name === name;
        });
    };
    Object.defineProperty(Filter.prototype, "activeFilters", {
        get: function () {
            return this.rules.filter(function (rule) {
                return rule.includeInFilterCount && rule.value != null;
            });
        },
        enumerable: false,
        configurable: true
    });
    return Filter;
}());
export default Filter;
